<script setup>
import { useForm, Head, Link } from '@inertiajs/vue3';
import moment from 'moment'
import 'moment/dist/locale/nl';;
import Dropdown from 'primevue/dropdown';
import { ref, watch, nextTick, onMounted, inject } from 'vue'
import { TabGroup, TabList, Tab, TabPanels, TabPanel, RadioGroup, RadioGroupOption, Disclosure, DisclosureButton, DisclosurePanel, Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot, Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import Rating from 'primevue/rating';
import InputNumber from 'primevue/inputnumber';
import Checkbox from 'primevue/checkbox';
import ConfettiExplosion from "vue-confetti-explosion";
import { Switch } from '@headlessui/vue';
import Header from '@/Components/Header.vue';
import Footer from '@/Components/Footer.vue';

const showCookie = ref(false)
const showCookieSettings = ref(false)
const acceptAnalytics = ref(false)
//check if cookies need to be shown
const $cookies = inject('$cookies');
if ($cookies.get('cookie-consent') === undefined || $cookies.get('cookie-consent') === null) {
    showCookie.value = true
} else {
    showCookie.value = false
}
function acceptCookies() {

    $cookies.set('cookie-consent', 'true', "1y");
    showCookie.value = false
    showCookieSettings.value = false
    if (acceptAnalytics.value) {
        //set cookie that anyalytics are accepted
        $cookies.set('cookie-analytics', 'true', "1y");

        setCookiesAsScripts();
    }
}

function acceptAllCookies() {
    $cookies.set('cookie-consent', 'true', "1y");

    $cookies.set('cookie-analytics', 'true', "1y");


    setCookiesAsScripts();
    showCookie.value = false
    showCookieSettings.value = false
}

function setCookiesAsScripts() {
    
    if (typeof gtag === 'function') {
        gtag('consent', 'update', {
            'ad_storage': $cookies.get('cookie-analytics') == "true" ? 'granted' : 'denied',
            'analytics_storage': $cookies.get('cookie-analytics') == "true" ? 'granted' : 'denied',
            'ad_user_data': $cookies.get('cookie-analytics') == "true" ? 'granted' : 'denied',
            'ad_personalization': $cookies.get('cookie-analytics') == "true" ? 'granted' : 'denied',
        });
    }
}

function checkCookies() {
    //check cookie-anaytics
    if ($cookies.get('cookie-analytics') !== undefined && $cookies.get('cookie-analytics') !== null) {
        setCookiesAsScripts();
    }
}

const selectedTab = ref(0);

function changeTab(index) {
    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 100);

    if (index < selectedTab.value) {
        selectedTab.value = index
        setSteps(index)
        return;
    }

    for (var i = selectedTab.value; i < index; i++) {
        if (i === 0) {
            //check if fields are filled
            let errors = checkBasic();

            if (errors.make || errors.model || errors.mileage || errors.fuelType || errors.transmission || errors.upholstery || errors.color || errors.carrosserie) {
                selectedTab.value = i;
                setSteps(i);

                form.errors = errors;
                return;
            }
        }

        if (i === 1) {
            //check if fields are filled
            let errors = checkState();

            if (errors.damagefreeStatus || errors.driveableStatus || errors.bookletsStatus || errors.exterior_state || errors.interior_state || errors.technical_state || errors.tire_state) {
                selectedTab.value = i;
                setSteps(i);

                form.errors = errors;
                return;
            }
        }

        if (i == 2) {
            let errors = checkOptions();

            if (errors.options || errors.options_extra) {
                selectedTab.value = i;
                setSteps(i);

                form.errors = errors;
                return;
            }
        }

        if (i === 3) {
            //check if fields are filled
            let errors = checkFinal();

            if (errors.saleElse || errors.phoneNumber || errors.emailAddress || errors.asking_price) {
                selectedTab.value = i;
                setSteps(i);

                form.errors = errors;
                return;
            }
        }
    }
    if (index == 4) {
        //form needs to be submitted, show confetti
        submit();
        return;
    }

    form.errors = {};
    selectedTab.value = index

    //set steps
    setSteps(index);
}

function checkOptions() {
    let errors = {};
    
    return errors;
}

function checkFinal() {
    let errors = {};

    if (form.saleElse === null || form.saleElse === "") {
        errors.saleElse = 'Verkoop elders is verplicht';
    }

    if (form.owner_name === null || form.owner_name === "") {
        errors.owner_name = 'Naam is verplicht';
    }

    if (form.phoneNumber === null || form.phoneNumber === "") {
        errors.phoneNumber = 'Telefoonnummer is verplicht';
    } else {
        //check if phone number is an actual phone number
        let phoneNumber = form.phoneNumber;
        let phoneNumberPattern = /^(0|\+31\s?)[1-9](\s?\d){8}$/;
        if (!phoneNumberPattern.test(phoneNumber)) {
            errors.phoneNumber = 'Telefoonnummer is ongeldig';
        }
    }

    if (form.emailAddress === null || form.emailAddress === "") {
        errors.emailAddress = 'E-mail is verplicht';
    } else {
        //check if email is an actual email
        let email = form.emailAddress;
        let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailPattern.test(email)) {
            errors.emailAddress = 'E-mail is ongeldig';
        }
    }

    if (form.asking_price === null || form.asking_price === "") {
        errors.asking_price = 'Vraagprijs is verplicht';
    }

    if (form.asking_price > 9999999) {
        errors.asking_price = 'Vraagprijs mag niet hoger zijn dan €9.999.999';
    }

    return errors;
}

function checkBasic() {
    let errors = {};
    if (form.make === null || form.make === '') {
        errors.make = 'Merk is verplicht';
    }

    if (form.model === null || form.model === '') {
        errors.model = 'Model is verplicht';
    }

    if (form.mileage === null || form.mileage === '') {
        errors.mileage = 'Kilometerstand is verplicht';
    }

    if (form.mileage > 3000000) {
        errors.mileage = 'Kilometerstand mag niet hoger zijn dan 3.000.000';
    }

    if (form.fuelType === null || form.fuelType === '') {
        errors.fuelType = 'Brandstof is verplicht';
    }

    if (form.transmission === null || form.transmission === '') {
        errors.transmission = 'Transmissie is verplicht';
    }

    if (form.construction_year === null || form.construction_year === '') {
        errors.construction_year = 'Bouwjaar is verplicht';
    }

    if (form.upholstery === null || form.upholstery === '') {
        errors.upholstery = 'Bekleding is verplicht';
    }

    if (form.color === null || form.color === '') {
        errors.color = 'Kleur is verplicht';
    }

    if (form.carrosserie === null || form.carrosserie === '') {
        errors.carrosserie = 'Carrosserie is verplicht';
    }

    if (form.make === null || form.make === '') {
        errors.make = 'Merk is verplicht';
    }

    if (form.model === null || form.model === '') {
        errors.model = 'Model is verplicht';
    }

    return errors;
}

function checkState() {
    let errors = {};
    if (form.damagefreeStatus === null || form.damagefreeStatus === "") {
        errors.damagefreeStatus = 'Schadevrij is verplicht';
    } else {
        if (form.damagefreeStatus == "nee") {
            if (form.driveableStatus === null || form.driveableStatus === "") {
                errors.driveableStatus = 'Rijdbaarheid is verplicht';
            }
        }
    }

    if (form.exterior_state == 0) {
        errors.exterior_state = 'Exterieur staat is verplicht';
    }

    if (form.interior_state == 0) {
        errors.interior_state = 'Interieur staat is verplicht';
    }

    if (form.technical_state == 0) {
        errors.technical_state = 'Technische staat is verplicht';
    }

    if (form.tire_state == 0) {
        errors.tire_state = 'Banden staat is verplicht';
    }

    if (form.bookletsStatus === null || form.bookletsStatus === "") {
        errors.bookletsStatus = 'Onderhoudsboekjes is verplicht';
    }

    return errors;
}

const showConfetti = ref(false);

const explode = async () => {
    showConfetti.value = false;
    await nextTick();
    showConfetti.value = true;
};

function setSteps(index) {
    for (let i = 0; i < steps.length; i++) {
        if (i > index) {
            steps[i].status = 'upcoming';
        } else if (i === index) {
            steps[i].status = 'current';
        } else {
            steps[i].status = 'complete';
        }
    }
}

const steps = [
    { name: 'Step 1', number: '1', href: '#', status: 'complete' },
    { name: 'Step 2', number: '2', href: '#', status: 'complete' },
    { name: 'Step 3', number: '3', href: '#', status: 'current' },
    { name: 'Step 4', number: '4', href: '#', status: 'upcoming' },
]

const props = defineProps({
    data: Object,
    bodyData: Object,
    powerData: Object,
    fuelType: String,
    licensePlate: String,
    options: Array
});

const carrosseries = [
    { "name": "Sedan", "value": "sedan" },
    { "name": "Hatchback", "value": "hatchback" },
    { "name": "Stationwagen", "value": "stationwagen" },
    { "name": "SUV", "value": "suv" },
    { "name": "Coupé", "value": "coupe" },
    { "name": "Cabriolet", "value": "cabriolet" },
    { "name": "MPV (Multi-Purpose Vehicle)", "value": "mpv" },
    { "name": "Pick-up", "value": "pick-up" },
    { "name": "Bestelwagen", "value": "bestelwagen" },
    { "name": "Sportwagen", "value": "sportwagen" },
    { "name": "Roadster", "value": "roadster" },
    { "name": "Limousine", "value": "limousine" },
    { "name": "Crossover", "value": "crossover" },
    { "name": "Overig", "value": "overig" }
]

const constructionYears = [];

for (let i = 0; i < 50; i++) {
    constructionYears.push(moment().year() - i);
}

const fuelTypes = [
    { "name": "Benzine", "value": "benzine" },
    { "name": "Diesel", "value": "diesel" },
    { "name": "Elektrisch", "value": "elektriciteit" },
    { "name": "LPG", "value": "lpg" },
    { "name": "Benzine-Elektrisch", "value": "benzine-elektriciteit" },
    { "name": "Diesel-Elektrisch", "value": "diesel-elektriciteit" },
]

const transmissionTypes = [
    { "name": "Handgeschakeld", "value": "handgeschakeld" },
    { "name": "Automaat", "value": "automaat" },
    { "name": "Semi-automaat", "value": "semi-automaat" },
]

const colors = [
    { "name": "Rood", "value": "rood" },
    { "name": "Blauw", "value": "blauw" },
    { "name": "Groen", "value": "groen" },
    { "name": "Zwart", "value": "zwart" },
    { "name": "Wit", "value": "wit" },
    { "name": "Grijs", "value": "grijs" },
    { "name": "Geel", "value": "geel" },
    { "name": "Oranje", "value": "oranje" },
    { "name": "Paars", "value": "paars" },
    { "name": "Roze", "value": "roze" },
    { "name": "Bruin", "value": "bruin" },
    { "name": "Beige", "value": "beige" },
    { "name": "Turquoise", "value": "turquoise" },
    { "name": "Zilver", "value": "zilver" },
    { "name": "Goud", "value": "goud" },
    { "name": "Chroom", "value": "chroom" },
    { "name": "Bronze", "value": "bronze" },
    { "name": "Overig", "value": "overig" },
]

const interiorTypes = [
    { "name": "Stof", "value": "stof" },
    { "name": "Leer", "value": "leer" },
    { "name": "Half leder", "value": "halfleer" },
    { "name": "Alcantara", "value": "alcantara" },
    { "name": "Overig", "value": "overig" },
]

let form;

if (props.licensePlate) {
    form = useForm({
        license_plate: props.licensePlate,
        make: props.data.merk.charAt(0).toUpperCase() + props.data.merk.toLowerCase().slice(1),
        model: props.data.handelsbenaming,
        mileage: null,
        fuelType: props.fuelType,
        color: props.data.eerste_kleur.toLowerCase() == 'n.v.t.' ? null : props.data.eerste_kleur.toLowerCase(),
        construction_year: moment(props.data.datum_eerste_toelating_dt).year(),
        images: [],
        carrosserie: props.bodyData.length > 0 ? props.bodyData[0]?.type_carrosserie_europese_omschrijving.toLowerCase() : null,
        transmission: null,
        asking_price: null,
        exterior_state: 0,
        interior_state: 0,
        technical_state: 0,
        tire_state: 0,
        upholstery: null,
        damagefreeStatus: null,
        driveableStatus: null,
        bookletsStatus: null,
        options: [],
        options_extra: "",
        saleElse: null,
        phoneNumber: null,
        emailAddress: null,
        owner_name: null,
    });
} else {
    form = useForm({
        license_plate: null,
        make: null,
        model: null,
        mileage: null,
        fuelType: null,
        color: null,
        construction_year: null,
        images: [],
        carrosserie: null,
        transmission: null,
        asking_price: null,
        exterior_state: 0,
        interior_state: 0,
        technical_state: 0,
        tire_state: 0,
        upholstery: null,
        damagefreeStatus: null,
        driveableStatus: null,
        bookletsStatus: null,
        options: [],
        options_extra: "",
        saleElse: null,
        phoneNumber: null,
        emailAddress: null,
        owner_name: null,
    });
}

const saveText = ref(null);
const saveButton = ref(null);

function submit() {
    //disable save button
    saveButton.value.disabled = true;

    saveText.value.innerHTML = 'Voertuig aan het aanmelden...';

    document.getElementById('saveSpinner').classList.remove('hidden');


    form.post('/autoaanmelden', {
        onSuccess: () => {
            selectedTab.value = 4;
            setSteps(4);
            explode();
        },
        onError: () => {
            //enable save button
            saveButton.value.disabled = false;

            saveText.value.innerHTML = 'Voertuig aanmelden';

            document.getElementById('saveSpinner').classList.add('hidden');

            //check where the error is, change to that tab
            if (form.errors.make || form.errors.model || form.errors.mileage || form.errors.fuelType || form.errors.transmission || form.errors.upholstery || form.errors.color || form.errors.carrosserie) {
                selectedTab.value = 0;
                setSteps(0);
                return;
            }

            if (form.errors.damagefreeStatus || form.errors.driveableStatus || form.errors.bookletsStatus || form.errors.exterior_state || form.errors.interior_state || form.errors.technical_state || form.errors.tire_state) {
                selectedTab.value = 1;
                setSteps(1);
                return;
            }

            if (form.errors.saleElse || form.errors.postalCode || form.errors.phoneNumber || form.errors.emailAddress || form.errors.asking_price) {
                selectedTab.value = 3;
                setSteps(3);
                return;
            }

        }
    });
}

const showDriveable = ref(false)
const showDeleteWarning = ref(false)

setSteps(0);

onMounted(() => {
    checkCookies();
})

function onFileChange(event) {
    const file = event.target.files;
    form.images = file;
}


const openingTimes = [
    {
        day: 1,
        open: '09:00',
        close: '20:00'
    },
    {
        day: 2,
        open: '09:00',
        close: '20:00'
    },
    {
        day: 3,
        open: '09:00',
        close: '20:00'
    },
    {
        day: 4,
        open: '09:00',
        close: '20:00'
    },
    {
        day: 5,
        open: '09:00',
        close: '20:00'
    },
    {
        day: 6,
        open: '09:00',
        close: '17:00'
    }
];

function isOpen() {
    const now = moment();
    const day = now.day();
    const time = now.format('HH:mm');

    const openingTime = openingTimes.find(time => time.day === day);
    if (!openingTime) {
        return false;
    }

    return time >= openingTime.open && time <= openingTime.close;
}

function openTime() {
    //get the day and get the closing time for this day
    const now = moment();
    const day = now.day();

    const openingTime = openingTimes.find(time => time.day === day);

    if (!openingTime) {
        return 'maandag 09:00';
    }

    return openingTime.open;
}

function closeTime() {
    //get the day and get the closing time for this day
    const now = moment();
    const day = now.day();

    const openingTime = openingTimes.find(time => time.day === day);

    if (!openingTime) {
        return false;
    }

    return openingTime.close;
}
</script>

<template>

    <Head title="Auto aanmelden">
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png">
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png">
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png">
        <link rel="manifest" href="/site.webmanifest">
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#ff5a22">
        <meta name="msapplication-TileColor" content="#ff5a22">
        <meta name="theme-color" content="#ffffff">

        <meta name="description" content="Jouw route naar autoverkoop!">

        <!-- Facebook Meta Tags -->
        <meta property="og:url" content="https://mas.codespreview.nl">
        <meta property="og:type" content="website">
        <meta property="og:title" content="Auto aanmelden | mijnautosnelweg.nl">
        <meta property="og:description" content="Jouw route naar autoverkoop!">
        <meta property="og:image" content="/img/og_image.png">

        <!-- Twitter Meta Tags -->
        <meta name="twitter:card" content="summary_large_image">
        <meta property="twitter:domain" content="mas.codespreview.nl">
        <meta property="twitter:url" content="https://mas.codespreview.nl">
        <meta name="twitter:title" content="Auto aanmelden | mijnautosnelweg.nl">
        <meta name="twitter:description" content="Jouw route naar autoverkoop!">
        <meta name="twitter:image" content="/img/og_image.png">


    </Head>
    <Header :isInnerPage="true" />
    <form @submit.prevent="submit"
        class="flex mt-10">
        <TabGroup :selectedIndex="selectedTab" @change="changeTab">
            <TabList class="hidden">
                <Tab>1</Tab>
                <Tab>2</Tab>
                <Tab>3</Tab>
                <Tab>4</Tab>
                <Tab>5</Tab>
            </TabList>
            <TabPanels class="w-full relative p-4 md:p-2">
                <TabPanel v-motion-fade-visible class="h-full min-h-fit flex mt-12">
                    <div class="flex flex-col my-20 mx-auto max-w-2xl gap-10">
                        <nav class="w-full" aria-label="Progress">
                            <ol role="list" class="flex items-center">
                                <li v-for="(step, stepIdx) in steps" :key="step.name"
                                    :class="[stepIdx !== steps.length - 1 ? 'pr-8 sm:pr-20 w-full' : '', 'relative']">
                                    <template v-if="step.status === 'complete'">
                                        <div class="absolute left-0 right-0 top-0 bottom-0 flex items-center w-full" aria-hidden="true">
                                            <div class="h-0.5 w-full bg-brightorange" />
                                        </div>
                                        <button @click="changeTab(stepIdx)" type="button"
                                            class="relative flex h-10 w-10 items-center justify-center rounded-full bg-brightorange">
                                            <font-awesome-icon :icon="['fal', 'check']"
                                                class="h-4 w-4 text-white shrink-0" />
                                            <span class="sr-only">{{ step.name }}</span>
                                        </button>
                                    </template>
                                    <template v-else-if="step.status === 'current'">
                                        <div class="absolute left-0 right-0 top-0 bottom-0 flex items-center w-full" aria-hidden="true">
                                            <div class="h-0.5 w-full bg-royalblue-500" />
                                        </div>
                                        <button type="button" @click="changeTab(stepIdx)"
                                            class="relative flex h-10 w-10 items-center justify-center rounded-full border-2 border-white bg-royalblue-500"
                                            aria-current="step">
                                            <span class="text-white">{{ step.number }}</span>
                                            <span class="sr-only">{{ step.name }}</span>
                                        </button>
                                    </template>
                                    <template v-else>
                                        <div class="absolute left-0 right-0 top-0 bottom-0 flex items-center w-full" aria-hidden="true">
                                            <div class="h-0.5 w-full bg-royalblue-500" />
                                        </div>
                                        <button type="button" @click="changeTab(stepIdx)"
                                            class="group relative flex h-10 w-10 items-center justify-center rounded-full border-2 border-royalblue-500 bg-white">
                                            <span class="text-royalblue-500">{{ step.number }}</span>
                                            <span class="sr-only">{{ step.name }}</span>
                                        </button>
                                    </template>
                                </li>
                            </ol>
                        </nav>
                        <h1 class="text-4xl text-royalblue-500 text-balance" id="stap_1">Laten we beginnen met wat basisinformatie.
                        </h1>
                        <div
                            class="flex flex-col gap-8 bg-white rounded-2xl p-4 sm:p-6 md:p-8 shadow-2xl shadow-deepblue/40">
                            <div class="flex flex-col gap-6">
                                <div class="flex flex-col gap-4">
                                    <div class="flex flex-col sm:flex-row gap-4">
                                        <div class="relative w-full">
                                            <label for="name" class="block text-sm leading-6 text-gray-900">Merk</label>
                                            <div class="relative mt-2 rounded-m ring-royalblue-500">
                                                <input id="make" v-model="form.make" name="make" autocomplete="make"
                                                    class="input-style" />
                                                <div v-if="form.errors.make"
                                                    class="pointer-events-none absolute top-0 bottom-0 right-0 flex items-center pr-3">
                                                    <font-awesome-icon :icon="['fal', 'triangle-exclamation']"
                                                        class="h-5 w-5 text-red-500 shrink-0" aria-hidden="true" />
                                                </div>
                                            </div>
                                            <p v-if="form.errors.make" class="text-red-500 text-sm pt-1">{{
                                                form.errors.make }}</p>
                                        </div>
                                        <div class="relative w-full">
                                            <label for="name"
                                                class="block text-sm leading-6 text-gray-900">Model</label>
                                            <div class="relative mt-2 rounded-m">
                                                <input id="model" v-model="form.model" name="model" autocomplete="model"
                                                    class="input-style" />
                                                <div v-if="form.errors.model"
                                                    class="pointer-events-none absolute top-0 bottom-0 right-0 flex items-center pr-3">
                                                    <font-awesome-icon :icon="['fal', 'triangle-exclamation']"
                                                        class="h-5 w-5 text-red-500 shrink-0" aria-hidden="true" />
                                                </div>
                                            </div>
                                            <p v-if="form.errors.model" class="text-red-500 text-sm pt-1">{{
                                                form.errors.model }}</p>
                                        </div>
                                    </div>
                                    <div class="flex flex-col sm:flex-row gap-4">
                                        <div class="relative w-full">
                                            <label for="name"
                                                class="block text-sm leading-6 text-gray-900">Kenteken</label>
                                            <div class="relative mt-2 rounded-m">
                                                <input id="license_plate" v-model="form.license_plate"
                                                    name="license_plate" autocomplete="license_plate"
                                                    class="input-style" />
                                                <div v-if="form.errors.license_plate"
                                                    class="pointer-events-none absolute top-0 bottom-0 right-0 flex items-center pr-3">
                                                    <font-awesome-icon :icon="['fal', 'triangle-exclamation']"
                                                        class="h-5 w-5 text-red-500 shrink-0" aria-hidden="true" />
                                                </div>
                                            </div>
                                            <p v-if="form.errors.license_plate" class="text-red-500 text-sm pt-1">{{
                                                form.errors.license_plate }}
                                            </p>
                                        </div>
                                        <div class="relative w-full">
                                            <label for="name"
                                                class="block text-sm leading-6 text-gray-900">Carrosserie</label>
                                            <div class="relative mt-2 rounded-m">
                                                <Dropdown :options="carrosseries" v-model="form.carrosserie"
                                                    optionLabel="name" optionValue="value" autocomplete="carrosserie"
                                                    class="dropdown-style">
                                                </Dropdown>
                                            </div>
                                            <p v-if="form.errors.carrosserie" class="text-red-500 text-sm pt-1">{{
                                                form.errors.carrosserie }}</p>
                                        </div>
                                    </div>
                                    <div class="flex flex-col sm:flex-row gap-4">
                                        <div class="relative w-full">
                                            <label for="name"
                                                class="block text-sm leading-6 text-gray-900">Bouwjaar</label>
                                            <div class="relative mt-2 rounded-m">
                                                <Dropdown :options="constructionYears" v-model="form.construction_year"
                                                    class="dropdown-style">
                                                </Dropdown>
                                            </div>
                                            <p v-if="form.errors.construction_year" class="text-red-500 text-sm pt-1">{{
                                                form.errors.construction_year }}</p>
                                        </div>
                                        <div class="relative w-full">
                                            <label for="name"
                                                class="block text-sm leading-6 text-gray-900">Kilometerstand</label>
                                            <div class="relative mt-2 rounded-m">
                                                <InputNumber v-model="form.mileage" inputId="mileage" locale="nl-NL"
                                                    :minFractionDigits="0" fluid class="input-style" />
                                                <div v-if="form.errors.mileage"
                                                    class="pointer-events-none absolute top-0 bottom-0 right-0 flex items-center pr-3">
                                                    <font-awesome-icon :icon="['fal', 'triangle-exclamation']"
                                                        class="h-5 w-5 text-red-500 shrink-0" aria-hidden="true" />
                                                </div>
                                            </div>
                                            <p v-if="form.errors.mileage" class="text-red-500 text-sm pt-1">{{
                                                form.errors.mileage }}</p>
                                        </div>
                                    </div>
                                    <div class="flex flex-col sm:flex-row gap-4">
                                        <div class="relative w-full">
                                            <label for="name"
                                                class="block text-sm leading-6 text-gray-900">Brandstof</label>
                                            <div class="relative mt-2 rounded-m">
                                                <Dropdown :options="fuelTypes" v-model="form.fuelType"
                                                    optionLabel="name" optionValue="value" class="dropdown-style">
                                                </Dropdown>
                                            </div>
                                            <p v-if="form.errors.fuelType" class="text-red-500 text-sm pt-1">{{
                                                form.errors.fuelType }}</p>
                                        </div>
                                        <div class="relative w-full">
                                            <label for="name"
                                                class="block text-sm leading-6 text-gray-900">Transmissie</label>
                                            <div class="relative mt-2 rounded-m">
                                                <Dropdown :options="transmissionTypes" v-model="form.transmission"
                                                    optionLabel="name" optionValue="value" class="dropdown-style">
                                                </Dropdown>
                                            </div>
                                            <p v-if="form.errors.transmission" class="text-red-500 text-sm pt-1">{{
                                                form.errors.transmission }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="flex flex-col sm:flex-row gap-4">
                                        <div class="relative w-full">
                                            <label for="name"
                                                class="block text-sm leading-6 text-gray-900">Kleur</label>
                                            <div class="relative mt-2 rounded-m">
                                                <Dropdown :options="colors" v-model="form.color" optionLabel="name"
                                                    optionValue="value" class="dropdown-style">
                                                </Dropdown>
                                            </div>
                                            <p v-if="form.errors.color" class="text-red-500 text-sm pt-1">{{
                                                form.errors.color }}</p>
                                        </div>
                                        <div class="relative w-full">
                                            <label for="name"
                                                class="block text-sm leading-6 text-gray-900">Bekleding</label>
                                            <div class="relative mt-2 rounded-m">
                                                <Dropdown :options="interiorTypes" v-model="form.upholstery"
                                                    optionLabel="name" optionValue="value" class="dropdown-style">
                                                </Dropdown>
                                            </div>
                                            <p v-if="form.errors.upholstery" class="text-red-500 text-sm pt-1">{{
                                                form.errors.upholstery }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex justify-end">
                                    <button @click="changeTab(1)" type="button" class="primary-btn">
                                        Volgende
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel v-motion-fade-visible class="h-full min-h-fit flex mt-12">
                    <div class="flex flex-col my-20 mx-auto max-w-2xl gap-10">
                        <nav class="w-full" aria-label="Progress">
                            <ol role="list" class="flex items-center">
                                <li v-for="(step, stepIdx) in steps" :key="step.name"
                                    :class="[stepIdx !== steps.length - 1 ? 'pr-8 sm:pr-20 w-full' : '', 'relative']">
                                    <template v-if="step.status === 'complete'">
                                        <div class="absolute left-0 right-0 top-0 bottom-0 flex items-center w-full" aria-hidden="true">
                                            <div class="h-0.5 w-full bg-brightorange" />
                                        </div>
                                        <button @click="changeTab(stepIdx)" type="button"
                                            class="relative flex h-10 w-10 items-center justify-center rounded-full bg-brightorange">
                                            <font-awesome-icon :icon="['fal', 'check']"
                                                class="h-4 w-4 text-white shrink-0" />
                                            <span class="sr-only">{{ step.name }}</span>
                                        </button>
                                    </template>
                                    <template v-else-if="step.status === 'current'">
                                        <div class="absolute left-0 right-0 top-0 bottom-0 flex items-center w-full" aria-hidden="true">
                                            <div class="h-0.5 w-full bg-royalblue-500" />
                                        </div>
                                        <button type="button" @click="changeTab(stepIdx)"
                                            class="relative flex h-10 w-10 items-center justify-center rounded-full border-2 border-white bg-royalblue-500"
                                            aria-current="step">
                                            <span class="text-white">{{ step.number }}</span>
                                            <span class="sr-only">{{ step.name }}</span>
                                        </button>
                                    </template>
                                    <template v-else>
                                        <div class="absolute left-0 right-0 top-0 bottom-0 flex items-center w-full" aria-hidden="true">
                                            <div class="h-0.5 w-full bg-royalblue-500" />
                                        </div>
                                        <button type="button" @click="changeTab(stepIdx)"
                                            class="group relative flex h-10 w-10 items-center justify-center rounded-full border-2 border-royalblue-500 bg-white">
                                            <span class="text-royalblue-500">{{ step.number }}</span>
                                            <span class="sr-only">{{ step.name }}</span>
                                        </button>
                                    </template>
                                </li>
                            </ol>
                        </nav>
                        <h1 class="text-4xl text-royalblue-500 text-balance" id="stap_2">Dan nog een aantal vragen over de staat van de auto.</h1>
                        <div
                            class="flex flex-col gap-8 bg-white rounded-2xl p-4 sm:p-6 md:p-8 shadow-2xl shadow-deepblue/40">
                            <div class="flex flex-col gap-6">
                                <div class="flex flex-col">
                                    <div class="flex flex-col md:flex-row gap-4 mb-4">
                                        <div class="relative w-full">
                                            <div
                                                class="flex flex-row md:flex-col items-center md:items-start justify-between">
                                                <label for="contactPreference"
                                                    class="block text-sm leading-6 text-gray-900">Wat is de staat van het exterieur?</label>
                                                <Rating class="relative mt-2" v-model="form.exterior_state"
                                                    :cancel="false" />
                                            </div>
                                            <p v-if="form.errors.exterior_state" class="text-red-500 text-sm pt-1">{{
                                                form.errors.exterior_state }}</p>
                                        </div>
                                        <div class="relative w-full">
                                            <div
                                                class="flex flex-row md:flex-col items-center md:items-start justify-between">
                                                <label for="contactPreference"
                                                    class="block text-sm leading-6 text-gray-900">Wat is de staat van het interieur?</label>
                                                <Rating class="relative mt-2" v-model="form.interior_state"
                                                    :cancel="false" />
                                            </div>
                                            <p v-if="form.errors.interior_state" class="text-red-500 text-sm pt-1">{{
                                                form.errors.interior_state }}</p>
                                        </div>
                                    </div>
                                    <div class="flex flex-col md:flex-row gap-4 mb-4">
                                        <div class="relative w-full">
                                            <div
                                                class="flex flex-row md:flex-col items-center md:items-start justify-between">
                                                <label for="contactPreference"
                                                    class="block text-sm leading-6 text-gray-900">Wat is de staat van de banden?</label>
                                                <Rating class="relative mt-2" v-model="form.tire_state"
                                                    :cancel="false" />
                                            </div>
                                            <p v-if="form.errors.tire_state" class="text-red-500 text-sm pt-1">{{
                                                form.errors.tire_state }}</p>
                                        </div>
                                        <div class="relative w-full">
                                            <div
                                                class="flex flex-row md:flex-col items-center md:items-start justify-between">
                                                <label for="contactPreference"
                                                    class="block text-sm leading-6 text-gray-900">Wat
                                                    is de technische staat?</label>
                                                <Rating class="relative mt-2" v-model="form.technical_state"
                                                    :cancel="false" />
                                            </div>
                                            <p v-if="form.errors.technical_state" class="text-red-500 text-sm pt-1">{{
                                                form.errors.technical_state }}</p>
                                        </div>
                                    </div>
                                    <div class="relative w-full mb-4">
                                        <div class="flex flex-row justify-between items-center">
                                            <label for="name" class="block text-sm leading-6 text-gray-900">Is de auto schadevrij?</label>
                                            <Popover class="relative">
                                                <PopoverButton class="flex items-center">
                                                    <font-awesome-icon :icon="['fal', 'circle-info']"
                                                        class="h-4 w-4 text-royalblue-500 shrink-0" />
                                                </PopoverButton>
                                                <PopoverPanel
                                                    class="absolute z-10 right-6 bottom-0 bg-white rounded-lg ring-1 ">
                                                    <div class="w-96 flex flex-col p-2">
                                                        <p class="text-sm text-gray-900">Schadevrij betekent dat de auto geen schade heeft gehad en geen schadeverleden heeft. Gebruikssporen vallen hier uiteraard niet onder.</p>
                                                    </div>
                                                    <img src="" alt="" />
                                                </PopoverPanel>
                                            </Popover>
                                        </div>
                                        <RadioGroup v-model="form.damagefreeStatus"
                                            class="flex flex-row gap-4 relative mt-2 h-11 items-center w-full">
                                            <RadioGroupOption @click="showDriveable = false" v-slot="{ checked }"
                                                value="ja" class="flex w-full">
                                                <span :class="checked ? 'selected-radio' : 'primary-radio'">Ja</span>
                                            </RadioGroupOption>
                                            <RadioGroupOption @click="showDriveable = true" v-slot="{ checked }"
                                                value="nee" class="flex w-full">
                                                <span :class="checked ? 'selected-radio' : 'primary-radio'">Nee</span>
                                            </RadioGroupOption>
                                        </RadioGroup>
                                        <p v-if="form.errors.damagefreeStatus" class="text-red-500 text-sm pt-1">{{
                                            form.errors.damagefreeStatus }}</p>
                                    </div>
                                    <div v-if="showDriveable" class="relative w-full mb-4">
                                        <div class="flex flex-row justify-between items-center">
                                            <label for="name" class="block text-sm leading-6 text-gray-900">Is de auto rijdbaar?</label>
                                            <Popover class="relative">
                                                <PopoverButton class="flex items-center">
                                                </PopoverButton>
                                                <PopoverPanel
                                                    class="absolute z-10 right-6 bottom-0 bg-white rounded-lg ring-1 ">
                                                    <div class="w-96 flex flex-col p-2">
                                                        <p class="text-sm text-gray-900">Rijdbaar betekent dat de auto op eigen kracht kan rijden en geen technische mankementen heeft.</p>
                                                    </div>
                                                    <img src="" alt="" />
                                                </PopoverPanel>
                                            </Popover>
                                        </div>
                                        <RadioGroup v-model="form.driveableStatus"
                                            class="flex flex-row gap-4 relative mt-2 h-11 items-center w-full">
                                            <RadioGroupOption v-slot="{ checked }" value="ja" class="flex w-full">
                                                <span :class="checked ? 'selected-radio' : 'primary-radio'">Ja</span>
                                            </RadioGroupOption>
                                            <RadioGroupOption v-slot="{ checked }" value="nee" class="flex w-full">
                                                <span :class="checked ? 'selected-radio' : 'primary-radio'">Nee</span>
                                            </RadioGroupOption>
                                        </RadioGroup>
                                        <p v-if="form.errors.driveableStatus" class="text-red-500 text-sm pt-1">{{
                                            form.errors.driveableStatus }}</p>
                                    </div>
                                    <div class="relative w-full mb-4">
                                        <label for="name"
                                            class="block text-sm leading-6 text-gray-900">Onderhoudsboekjes
                                            aanwezig?</label>
                                        <RadioGroup v-model="form.bookletsStatus"
                                            class="flex flex-row gap-4 relative mt-2 h-11 items-center w-full">
                                            <RadioGroupOption v-slot="{ checked }" value="ja" class="flex w-full">
                                                <span :class="checked ? 'selected-radio' : 'primary-radio'">Ja</span>
                                            </RadioGroupOption>
                                            <RadioGroupOption v-slot="{ checked }" value="nee" class="flex w-full">
                                                <span :class="checked ? 'selected-radio' : 'primary-radio'">Nee</span>
                                            </RadioGroupOption>
                                        </RadioGroup>
                                        <p v-if="form.errors.bookletsStatus" class="text-red-500 text-sm pt-1">{{
                                            form.errors.bookletsStatus }}</p>
                                    </div>
                                </div>
                                <div class="flex justify-end gap-3">
                                    <button @click="changeTab(0)" type="button" class="secondary-btn">
                                        Vorige
                                    </button>
                                    <button @click="changeTab(2)" type="button" class="primary-btn">
                                        Volgende
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel v-motion-fade-visible class="h-full min-h-fit flex mt-12">
                    <div class="flex flex-col my-20 mx-auto max-w-2xl gap-10">
                        <nav class="w-full" aria-label="Progress">
                            <ol role="list" class="flex items-center">
                                <li v-for="(step, stepIdx) in steps" :key="step.name"
                                    :class="[stepIdx !== steps.length - 1 ? 'pr-8 sm:pr-20 w-full' : '', 'relative']">
                                    <template v-if="step.status === 'complete'">
                                        <div class="absolute left-0 right-0 top-0 bottom-0 flex items-center w-full" aria-hidden="true">
                                            <div class="h-0.5 w-full bg-brightorange" />
                                        </div>
                                        <button @click="changeTab(stepIdx)" type="button"
                                            class="relative flex h-10 w-10 items-center justify-center rounded-full bg-brightorange">
                                            <font-awesome-icon :icon="['fal', 'check']"
                                                class="h-4 w-4 text-white shrink-0" />
                                            <span class="sr-only">{{ step.name }}</span>
                                        </button>
                                    </template>
                                    <template v-else-if="step.status === 'current'">
                                        <div class="absolute left-0 right-0 top-0 bottom-0 flex items-center w-full" aria-hidden="true">
                                            <div class="h-0.5 w-full bg-royalblue-500" />
                                        </div>
                                        <button type="button" @click="changeTab(stepIdx)"
                                            class="relative flex h-10 w-10 items-center justify-center rounded-full border-2 border-white bg-royalblue-500"
                                            aria-current="step">
                                            <span class="text-white">{{ step.number }}</span>
                                            <span class="sr-only">{{ step.name }}</span>
                                        </button>
                                    </template>
                                    <template v-else>
                                        <div class="absolute left-0 right-0 top-0 bottom-0 flex items-center w-full" aria-hidden="true">
                                            <div class="h-0.5 w-full bg-royalblue-500" />
                                        </div>
                                        <button type="button" @click="changeTab(stepIdx)"
                                            class="group relative flex h-10 w-10 items-center justify-center rounded-full border-2 border-royalblue-500 bg-white">
                                            <span class="text-royalblue-500">{{ step.number }}</span>
                                            <span class="sr-only">{{ step.name }}</span>
                                        </button>
                                    </template>
                                </li>
                            </ol>
                        </nav>
                        <h1 class="text-4xl text-royalblue-500 text-balance" id="stap_3">Klik hier dan nog even de opties aan.</h1>
                        <div class="flex flex-col gap-8 bg-white rounded-2xl p-8 shadow-2xl shadow-deepblue/40">
                            <div class="flex flex-col gap-6">
                                <div class="relative w-full">
                                    <label for="name" class="block text-sm leading-6 text-gray-900">Heeft je auto één of
                                        meerdere onderstaande opties?</label>
                                    <div class="flex flex-wrap gap-x-2 gap-y-7 relative items-center w-full mt-3">
                                        <div v-for="option in props.options">
                                            <Checkbox v-model="form.options" :value="option.id"
                                                :inputId="'option_' + option.id" class="hidden" />
                                            <label :for="'option_' + option.id"
                                                :class="form.options.includes(option.id) ? 'bg-royalblue-500 text-white' : 'bg-transparent'"
                                                class="border p-2 rounded-lg hover:bg-royalblue-500/80 text-gray-900 hover:text-white cursor-pointer transition-colors duration-200 ease-in-out">{{
                                                    option.name }}</label>
                                        </div>
                                    </div>
                                    <p v-if="form.errors.fuelTypes" class="text-red-500 text-sm pt-1">{{
                                        form.errors.fuelTypes }}</p>
                                </div>
                                <div class="flex justify-end gap-3">
                                    <button @click="changeTab(1)" type="button" class="secondary-btn">
                                        Vorige
                                    </button>
                                    <button @click="changeTab(3)" type="button" class="primary-btn">
                                        Volgende
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel v-motion-fade-visible class="h-full min-h-fit flex mt-12">
                    <div class="flex flex-col my-20 mx-auto gap-10">
                        <nav class="w-full max-w-2xl mx-auto" aria-label="Progress">
                            <ol role="list" class="flex items-center">
                                <li v-for="(step, stepIdx) in steps" :key="step.name"
                                    :class="[stepIdx !== steps.length - 1 ? 'pr-8 sm:pr-20 w-full' : '', 'relative']">
                                    <template v-if="step.status === 'complete'">
                                        <div class="absolute left-0 right-0 top-0 bottom-0 flex items-center w-full" aria-hidden="true">
                                            <div class="h-0.5 w-full bg-brightorange" />
                                        </div>
                                        <button @click="changeTab(stepIdx)" type="button"
                                            class="relative flex h-10 w-10 items-center justify-center rounded-full bg-brightorange">
                                            <font-awesome-icon :icon="['fal', 'check']"
                                                class="h-4 w-4 text-white shrink-0" />
                                            <span class="sr-only">{{ step.name }}</span>
                                        </button>
                                    </template>
                                    <template v-else-if="step.status === 'current'">
                                        <div class="absolute left-0 right-0 top-0 bottom-0 flex items-center w-full" aria-hidden="true">
                                            <div class="h-0.5 w-full bg-royalblue-500" />
                                        </div>
                                        <button type="button" @click="changeTab(stepIdx)"
                                            class="relative flex h-10 w-10 items-center justify-center rounded-full border-2 border-white bg-royalblue-500"
                                            aria-current="step">
                                            <span class="text-white">{{ step.number }}</span>
                                            <span class="sr-only">{{ step.name }}</span>
                                        </button>
                                    </template>
                                    <template v-else>
                                        <div class="absolute left-0 right-0 top-0 bottom-0 flex items-center w-full" aria-hidden="true">
                                            <div class="h-0.5 w-full bg-royalblue-500" />
                                        </div>
                                        <button type="button" @click="changeTab(stepIdx)"
                                            class="group relative flex h-10 w-10 items-center justify-center rounded-full border-2 border-royalblue-500 bg-white">
                                            <span class="text-royalblue-500">{{ step.number }}</span>
                                            <span class="sr-only">{{ step.name }}</span>
                                        </button>
                                    </template>
                                </li>
                            </ol>
                        </nav>
                        <h1 class="text-4xl text-royalblue-500 text-balance max-w-2xl mx-auto" id="stap_4">De laatste informatie en dan kunnen we aan
                            de slag!</h1>
                        <div class="flex flex-col lg:flex-row gap-8 bg-white rounded-2xl p-8 shadow-2xl shadow-deepblue/40 ">
                            <div class="flex flex-col gap-6">
                                <div class="flex flex-col gap-4">
                                    <div class="relative w-full">
                                        <label for="name" class="block text-sm leading-6 text-gray-900">Staat de auto
                                            elders
                                            te koop?</label>
                                        <RadioGroup v-model="form.saleElse"
                                            class="flex flex-row gap-4 relative mt-2 h-11 items-center w-full">
                                            <RadioGroupOption v-slot="{ checked }" value="ja" class="flex w-full">
                                                <span :class="checked ? 'selected-radio' : 'primary-radio'">Ja</span>
                                            </RadioGroupOption>
                                            <RadioGroupOption v-slot="{ checked }" value="nee" class="flex w-full">
                                                <span :class="checked ? 'selected-radio' : 'primary-radio'">Nee</span>
                                            </RadioGroupOption>
                                        </RadioGroup>
                                        <p v-if="form.errors.saleElse" class="text-red-500 text-sm pt-1">{{
                                            form.errors.saleElse }}</p>
                                    </div>
                                    <div class="flex flex-col md:flex-row gap-4">
                                        <div class="relative w-full">
                                            <div class="flex flex-row justify-between items-center">
                                                <label for="name" class="block text-sm leading-6 text-gray-900">Vraagprijs</label>
                                                <Popover class="relative">
                                                    <PopoverButton class="flex items-center">
                                                        <font-awesome-icon :icon="['fal', 'circle-info']"
                                                            class="h-4 w-4 text-royalblue-500 shrink-0" />
                                                    </PopoverButton>

                                                    <PopoverPanel
                                                        class="absolute z-10 right-6 bottom-0 bg-white rounded-lg ring-1 ">
                                                        <div class="w-64 flex flex-col p-2">
                                                            <p class="text-sm text-gray-900">We gebruiken je
                                                                vraagprijs als een indicatiebedrag in het verkoop
                                                                proces. Indien het een zakelijke auto betreft, prijs incl. BTW invullen.
                                                            </p>
                                                        </div>

                                                        <img src="" alt="" />
                                                    </PopoverPanel>
                                                </Popover>
                                            </div>
                                            <div class="relative mt-2 rounded-m">
                                                <InputNumber v-model="form.asking_price" inputId="currency-netherlands"
                                                    mode="currency" currency="EUR" locale="nl-NL"
                                                    class="block w-full rounded-md border-0 bg-white text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-royalblue-500 sm:text-sm sm:leading-6" />
                                                <div v-if="form.errors.asking_price"
                                                    class="pointer-events-none absolute top-0 bottom-0 right-0 flex items-center pr-3">
                                                    <font-awesome-icon :icon="['fal', 'triangle-exclamation']"
                                                        class="h-5 w-5 text-red-500 shrink-0" aria-hidden="true" />
                                                </div>
                                            </div>
                                            <p v-if="form.errors.asking_price" class="text-red-500 text-sm pt-1">{{
                                                form.errors.asking_price }}</p>
                                        </div>
                                        <div class="relative w-full flex flex-row gap-4">
                                            <div class="relative w-full">
                                            <div class="flex flex-row justify-between items-center">
                                                <label for="name" class="block text-sm leading-6 text-gray-900">Naam</label>
                                                <Popover class="relative">
                                                    <PopoverButton class="flex items-center">
                                                        <font-awesome-icon :icon="['fal', 'circle-info']"
                                                            class="h-4 w-4 text-royalblue-500 shrink-0" />
                                                    </PopoverButton>

                                                    <PopoverPanel
                                                        class="absolute z-10 right-6 bottom-0 bg-white rounded-lg ring-1 ">
                                                        <div class="w-64 flex flex-col p-2">
                                                            <p class="text-sm text-gray-900">We gebruiken je
                                                                naam om gepersonaliseerde e-mails te sturen
                                                            </p>
                                                        </div>

                                                        <img src="" alt="" />
                                                    </PopoverPanel>
                                                </Popover>
                                            </div>
                                            <div class="relative mt-2 rounded-m">
                                                <input id="name" v-model="form.owner_name" name="name" type="text"
                                                    class="input-style" />
                                                <div v-if="form.errors.owner_name"
                                                    class="pointer-events-none absolute top-0 bottom-0 right-0 flex items-center pr-3">
                                                    <font-awesome-icon :icon="['fal', 'triangle-exclamation']"
                                                        class="h-5 w-5 text-red-500 shrink-0" aria-hidden="true" />
                                                </div>
                                            </div>
                                            <p v-if="form.errors.owner_name" class="text-red-500 text-sm pt-1">{{
                                                form.errors.owner_name }}</p>
                                        </div>
                                        </div>
                                    </div>
                                    <div class="flex flex-col md:flex-row gap-4 mb-4">
                                        <div class="relative w-full">
                                            <div class="flex flex-row justify-between items-center">
                                                <label for="name"
                                                    class="block text-sm leading-6 text-gray-900">Telefoonnummer</label>
                                                <Popover class="relative">
                                                    <PopoverButton class="flex items-center">
                                                        <font-awesome-icon :icon="['fal', 'circle-info']"
                                                            class="h-4 w-4 text-royalblue-500 shrink-0" />
                                                    </PopoverButton>

                                                    <PopoverPanel
                                                        class="absolute z-10 right-6 bottom-0 bg-white rounded-lg ring-1 ">
                                                        <div class="w-64 flex flex-col p-2">
                                                            <p class="text-sm text-gray-900">We gebruiken je
                                                                telefoonnummer om je op de hoogte te houden van de
                                                                status van je auto en niets meer.</p>
                                                        </div>

                                                        <img src="" alt="" />
                                                    </PopoverPanel>
                                                </Popover>
                                            </div>
                                            <div class="relative mt-2 rounded-m">
                                                <input id="phone_number" v-model="form.phoneNumber" name="phoneNumber" type="tel"
                                                    class="input-style" />
                                                <div v-if="form.errors.phoneNumber"
                                                    class="pointer-events-none absolute top-0 bottom-0 right-0 flex items-center pr-3">
                                                    <font-awesome-icon :icon="['fal', 'triangle-exclamation']"
                                                        class="h-5 w-5 text-red-500 shrink-0" aria-hidden="true" />
                                                </div>
                                            </div>
                                            <p v-if="form.errors.phoneNumber" class="text-red-500 text-sm pt-1">{{
                                                form.errors.phoneNumber }}</p>
                                        </div>
                                        <div class="relative w-full">
                                            <div class="flex flex-row justify-between items-center">
                                                <label for="name"
                                                    class="block text-sm leading-6 text-gray-900">E-mail</label>
                                                <Popover class="relative">
                                                    <PopoverButton class="flex items-center">
                                                        <font-awesome-icon :icon="['fal', 'circle-info']"
                                                            class="h-4 w-4 text-royalblue-500 shrink-0" />
                                                    </PopoverButton>

                                                    <PopoverPanel
                                                        class="absolute z-10 right-6 bottom-0 bg-white rounded-lg ring-1 ">
                                                        <div class="w-64 flex flex-col p-2">
                                                            <p class="text-sm text-gray-900">We gebruiken je e-mailadres
                                                                om je op de hoogte te houden van de status van je auto
                                                                en niets meer.
                                                            </p>
                                                        </div>
                                                    </PopoverPanel>
                                                </Popover>
                                            </div>
                                            <div class="relative mt-2 rounded-m">
                                                <input id="email_address" v-model="form.emailAddress" type="email"
                                                    name="emailAddress" class="input-style" />
                                                <div v-if="form.errors.emailAddress"
                                                    class="pointer-events-none absolute top-0 bottom-0 right-0 flex items-center pr-3">
                                                    <font-awesome-icon :icon="['fal', 'triangle-exclamation']"
                                                        class="h-5 w-5 text-red-500 shrink-0" aria-hidden="true" />
                                                </div>
                                            </div>
                                            <p v-if="form.errors.emailAddress" class="text-red-500 text-sm pt-1">{{
                                                form.errors.emailAddress }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex justify-end gap-3">
                                    <button @click="changeTab(2)" type="button" class="secondary-btn">
                                        Vorige
                                    </button>
                                    <button @click="changeTab(4)" type="button" class="primary-btn" ref="saveButton">
                                        <font-awesome-icon id="saveSpinner" class="hidden animate-spin" :icon="['far', 'spinner']" /> <span ref="saveText">Meld mijn voertuig aan</span>
                                    </button>
                                </div>

                                <div class="text-center italic text-sm">
                                    Binnen 24 uur ontvang je een gratis én vrijblijvend bod.
                                </div>
                            </div>
                            <div class="flex flex-col gap-6 lg:w-[500px]">
                                <div class="flex flex-col gap-4 text-sm">
                                    <h1 class="font-semibold text-xl">Maak je aanmelding af en ontvang direct een persoonlijk bod!</h1>

                                    <p class="mb-2">
                                        Bij ons krijg je niet zomaar een taxatie, maar een zorgvuldig samengesteld bod dat perfect aansluit bij 
                                        jouw voertuig. Vul de laatste gegevens in en ontdek hoe eenvoudig het is om je auto via ons te verkopen.
                                    </p>

                                    <ul class="flex flex-col gap-1">
                                        <li class="flex items-center gap-2">
                                            <font-awesome-icon :icon="['far', 'check-circle']" class="text-green-500" />
                                            <span>Snel en transparant: Binnen korte tijd een eerlijk bod.</span>
                                        </li>
                                        <li class="flex items-center gap-2">
                                            <font-awesome-icon :icon="['far', 'check-circle']" class="text-green-500" />
                                            <span>Geen verplichtingen: Jij beslist wat je doet.</span>
                                        </li>
                                        <li class="flex items-center gap-2">
                                            <font-awesome-icon :icon="['far', 'check-circle']" class="text-green-500" />
                                            <span>Professionele service: Wij regelen alles voor je.</span>
                                        </li>
                                    </ul>

                                    <ul class="flex flex-col gap-1">
                                        <li class="flex items-center gap-2">
                                            <font-awesome-icon :icon="['far', 'xmark']" class="text-red-500" />
                                            <span>Onderhandelingen of lastige kopers</span>
                                        </li>
                                        <li class="flex items-center gap-2">
                                            <font-awesome-icon :icon="['far', 'xmark']" class="text-red-500" />
                                            <span>Vreemden die bij je aan de deur komen.</span>
                                        </li>
                                        <li class="flex items-center gap-2">
                                            <font-awesome-icon :icon="['far', 'xmark']" class="text-red-500" />
                                            <span>Verborgen kosten of verrassingen.</span>
                                        </li>
                                    </ul>

                                    <p class="mt-2">
                                        Maak je aanmelding nu af en ontvang een persoonlijk bod op jouw auto. Zo simpel kan het zijn!
                                    </p>

                                    <p class="">
                                        <strong>"Klik, tik en verkocht!"</strong><br />
                                        Sneller dan jij kan zeggen.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel v-motion-fade-visible class="h-full min-h-fit flex mt-12">
                    <div class="flex flex-col my-20 mx-auto max-w-2xl gap-10">
                        <nav class="w-full" aria-label="Progress">
                            <ol role="list" class="flex items-center">
                                <li v-for="(step, stepIdx) in steps" :key="step.name"
                                    :class="[stepIdx !== steps.length - 1 ? 'pr-8 sm:pr-20 w-full' : '', 'relative']">
                                    <template v-if="step.status === 'complete'">
                                        <div class="absolute left-0 right-0 top-0 bottom-0 flex items-center w-full" aria-hidden="true">
                                            <div class="h-0.5 w-full bg-brightorange" />
                                        </div>
                                        <button type="button"
                                            class="relative flex h-10 w-10 items-center justify-center rounded-full bg-brightorange">
                                            <font-awesome-icon :icon="['fal', 'check']"
                                                class="h-4 w-4 text-white shrink-0" />
                                            <span class="sr-only">{{ step.name }}</span>
                                        </button>
                                    </template>
                                    <template v-else-if="step.status === 'current'">
                                        <div class="absolute left-0 right-0 top-0 bottom-0 flex items-center w-full" aria-hidden="true">
                                            <div class="h-0.5 w-full bg-royalblue-500" />
                                        </div>
                                        <button type="button"
                                            class="relative flex h-10 w-10 items-center justify-center rounded-full border-2 border-white bg-royalblue-500"
                                            aria-current="step">
                                            <span class="text-white">{{ step.number }}</span>
                                            <span class="sr-only">{{ step.name }}</span>
                                        </button>
                                    </template>
                                    <template v-else>
                                        <div class="absolute left-0 right-0 top-0 bottom-0 flex items-center w-full" aria-hidden="true">
                                            <div class="h-0.5 w-full bg-royalblue-500" />
                                        </div>
                                        <button type="button"
                                            class="group relative flex h-10 w-10 items-center justify-center rounded-full border-2 border-royalblue-500 bg-white">
                                            <span class="text-royalblue-500">{{ step.number }}</span>
                                            <span class="sr-only">{{ step.name }}</span>
                                        </button>
                                    </template>
                                </li>
                            </ol>
                        </nav>
                        <h1 class="text-4xl text-royalblue-500 text-center text-balance pb-96" id="stap_done">Geweldig! Wij gaan aan de slag
                            met de verkoop van jouw auto.</h1>

                        <div class="relative">
                            <ConfettiExplosion :particleCount="300" :force="0.3" :duration="5000" v-if="showConfetti"
                                class="absolute mx-auto -mt-[190px]" />
                        </div>
                    </div>
                </TabPanel>
                <div class="absolute h-full w-full inset-0 -z-40 flex flex-col">
                    <div class="h-fit flex grow w-full bg-white"></div>
                    <div class="h-3/6 w-full bg-gradient-to-b from-transparent to-royalblue-500 via-lessbrightorange via-35%"></div>
                </div>
            </TabPanels>
        </TabGroup>
    </form>
    <!-- Footer section -->
    <Footer />

    <TransitionRoot as="template" :show="showDeleteWarning">
        <Dialog class="relative z-50" @close="showDeleteWarning = false">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed left-0 right-0 top-0 bottom-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div class="fixed left-0 right-0 top-0 bottom-0 z-10 w-screen overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel
                            class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                            <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                <button type="button"
                                    class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                    @click="showDeleteWarning = false">
                                    <span class="sr-only">Close</span>
                                    <font-awesome-icon :icon="['far', 'xmark']" class="h-6 w-6 shrink-0" />
                                </button>
                            </div>
                            <div class="sm:flex sm:items-start">
                                <div
                                    class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-royalblue-500/20 sm:mx-0 sm:h-10 sm:w-10">
                                    <font-awesome-icon :icon="['fal', 'triangle-exclamation']"
                                        class="h-6 w-6 text-royalblue-500 shrink-0" aria-hidden="true" />
                                </div>
                                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">
                                        Foto verwijderen</DialogTitle>
                                    <div class="mt-2">
                                        <p class="text-sm text-gray-500">Weet je het zeker dat je deze foto wilt
                                            verwijderen? Deze foto zal worden verwijderd en zal opnieuw moeten worden
                                            geupload.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-x-3">
                                <button type="button" class="primary-btn"
                                    @click="showDeleteWarning = false">Verwijder</button>
                                <button type="button" class="tertiary-btn"
                                    @click="showDeleteWarning = false">Annuleren</button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>

    <div v-if="showCookie" class="fixed bottom-0 left-0 right-0 border-t-2 border-royalblue-500 bg-white w-full flex items-center justify-between gap-4 px-6 py-3">
        <p class="text-balance text-center md:text-left">Mijnautosnelweg maakt gebruik van cookies om onze website te verbeteren, maar alleen met jouw toestemming. Bij instellingen lees je meer over hoe het werkt en indien nodig kun je hier ook de cookies aanpassen.</p>
        <div class="flex flex-row gap-4 items-center">
            <a @click="showCookieSettings = true;" class="group transition-all duration-300 ease-in-out inline-flex items-center border-b-2 border-transparent pt-1 text-base font-base  text-royalblue-500 hover:text-royalblue-500/80">
                <span class="bg-left-bottom bg-gradient-to-r from-brightorange to-brightorange bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out">
                    Instellingen
                </span>
            </a>
            <a @click="acceptAllCookies" class="primary-btn">Accepteren</a>
        </div>
    </div>

    <TransitionRoot as="template" :show="showCookieSettings">
        <Dialog as="div" class="relative z-50">
            <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel
                            class="relative transform overflow-clip rounded-lg bg-white border shadow-deepblue/40 shadow-3xl px-4 pb-4 pt-5 text-left transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
                            <div
                                class="flex flex-col gap-4 p-4 overflow-y-auto  max-h-[512px] sm:max-h-[628px] md:max-h-[745px]">
                                                <div class="flex justify-between items-center mb-4 rounded-t sm:mb-5">
                                    <DialogTitle>
                                        <img class="h-8 w-auto mt-2" src="/public/img/logo_full.svg"
                                            alt="mijnautosnelweg" />
                                    </DialogTitle>
                                </div>
                                <form action="#">
                                    <div class="mb-4 border-b">
                                        <h4 class="block mb-2 text-lg font-semibold text-gray-900 ">Cookie instellingen
                                        </h4>
                                        <p class="block mb-4 text-sm text-gray-900 ">Om deze Diensten te gebruiken,
                                            hebben we uw toestemming nodig. Door op “Alles accepteren” te klikken,
                                            verklaart u uw toestemming voor het gebruik van alle Diensten. U kunt ook uw
                                            toestemming verklaren door individueel op de schuifregelaars voor elke
                                            categorie cookies te klikken en opslaan.</p>
                                    </div>
                                    <div class="mb-4 border-b">
                                        <h4 class="block mb-2 text-lg font-semibold text-gray-900 ">Essentiele cookies
                                        </h4>
                                        <p class="block mb-4 text-sm text-gray-900 ">Om deze Diensten te gebruiken,
                                            hebben we uw toestemming nodig. Door op “Alles accepteren” te klikken,
                                            verklaart u uw toestemming voor het gebruik van alle Diensten. U kunt ook uw
                                            toestemming verklaren door individueel op de schuifregelaars voor elke
                                            categorie cookies te klikken en opslaan.</p>
                                        <button v-if="!showEssential" type="button"
                                            class="mb-4 flex flex-row items-center gap-2 text-sm font-medium text-royalblue-500 hover:text-royalblue-500/80"
                                            @click="showEssential = true">
                                            <p>Cookies bekijken</p>
                                            <font-awesome-icon :icon="['far', 'chevron-right']"
                                                class="h-4 w-4 shrink-0" />
                                        </button>
                                        <button v-if="showEssential" type="button"
                                            class="mb-4 flex flex-row items-center gap-2 text-sm font-medium text-royalblue-500 hover:text-royalblue-500/80"
                                            @click="showEssential = false">
                                            <p>Cookies bekijken</p>
                                            <font-awesome-icon :icon="['far', 'chevron-down']"
                                                class="h-4 w-4 shrink-0" />
                                        </button>
                                        <div v-if="showEssential" class="transition-all duration-300 ease-in-out">
                                            <div class="mt-10 ring-1 ring-gray-300 mx-0 rounded-lg overflow-hidden">
                                                <table class="min-w-full divide-y divide-gray-300 border-b">
                                                    <thead class="bg-royalblue-500/5">
                                                        <tr>
                                                            <th scope="col"
                                                                class="table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                                                                Naam
                                                            </th>
                                                            <th scope="col"
                                                                class="table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                                                                Expiration
                                                            </th>
                                                            <th scope="col"
                                                                class="table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                                                                Purpose
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="divide-y">
                                                        <tr>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                mijnautosnelweg_session
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                2 uur
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                Zorgt dat je dat data veilig verstuurd word
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                XSRF-TOKEN
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                2 uur
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                Zorgt voor een naadloze ervaring
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                fontsCssCache
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                7 dagen
                                                            </td>
                                                            <td
                                                                class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500">
                                                                Geeft aan of de fonts al ingeladen zijn
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-4 border-b">
                                        <div class="relative flex justify-between">
                                            <h4 class="block mb-2 text-lg font-semibold text-gray-900 ">Analytics
                                                cookies</h4>
                                            <Switch v-model="acceptAnalytics"
                                                class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none">
                                                <span class="sr-only">Use setting</span>
                                                <span aria-hidden="true"
                                                    class="pointer-events-none absolute h-full w-full rounded-md" />
                                                <span aria-hidden="true"
                                                    :class="[acceptAnalytics ? 'bg-brightorange' : 'bg-gray-200', 'pointer-events-none absolute mx-auto h-6 w-12 rounded-full transition-colors duration-200 ease-in-out']" />
                                                <span aria-hidden="true"
                                                    :class="[acceptAnalytics ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out']" />
                                            </Switch>
                                        </div>
                                        <p class="block mb-4 text-sm text-gray-900 ">Om deze Diensten te gebruiken,
                                            hebben we uw toestemming nodig. Door op “Alles accepteren” te klikken,
                                            verklaart u uw toestemming voor het gebruik van alle Diensten. U kunt ook uw
                                            toestemming verklaren door individueel op de schuifregelaars voor elke
                                            categorie cookies te klikken en opslaan.</p>
                                        <button v-if="!showAnalytics" type="button"
                                            class="mb-4 flex flex-row items-center gap-2 text-sm font-medium text-royalblue-500 hover:text-royalblue-500/80"
                                            @click="showAnalytics = true">
                                            <p>Cookies bekijken</p>
                                            <font-awesome-icon :icon="['far', 'chevron-right']"
                                                class="h-4 w-4 shrink-0" />
                                        </button>
                                        <button v-if="showAnalytics" type="button"
                                            class="mb-4 flex flex-row items-center gap-2 text-sm font-medium text-royalblue-500 hover:text-royalblue-500/80"
                                            @click="showAnalytics = false">
                                            <p>Cookies bekijken</p>
                                            <font-awesome-icon :icon="['far', 'chevron-down']"
                                                class="h-4 w-4 shrink-0" />
                                        </button>
                                        <div v-if="showAnalytics" class="transition-all duration-300 ease-in-out">
                                            <table class="mt-4 mb-4 w-full border bg-white rounded-xl overflow-hidden">
                                                <thead class="border-b bg-royalblue-500/5">
                                                    <tr>
                                                        <th class="px-4 py-2 text-left">Naam</th>
                                                        <th class="px-4 py-2 text-left">Expiration</th>
                                                        <th class="px-4 py-2 text-left">Purpose</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>_ga</p>
                                                        </th>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>2 Jaar</p>
                                                        </th>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>Google analytics</p>
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>_ga_KQVNRHT4TX</p>
                                                        </th>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>2 Jaar</p>
                                                        </th>
                                                        <th class="px-4 py-2 font-normal">
                                                            <p>Google analytics</p>
                                                        </th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </form>
                                <div class="mt-4 flex justify-end items-center space-x-6">
                                    <button @click="acceptCookies" type="button" class="group transition-all duration-300 ease-in-out inline-flex items-center border-b-2 border-transparent pt-1 text-base font-semibold  text-royalblue-500 hover:text-royalblue-500/80">
                                        <span class="bg-left-bottom bg-gradient-to-r from-brightorange to-brightorange bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out">
                                            Opslaan en verder
                                        </span>
                                    </button>
                                    <button type="button"
                                        class="inline-flex w-auto justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 sm:col-start-2"
                                        @click="acceptAllCookies">Alles accepteren</button>
                                </div>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
